module.exports = __webpack_public_path__ + "img/tab5.49178b58.png";